import { API, post } from '../../net/http';

export default {
  namespaced: true,
  actions: {
    searchOrder(context, body) {
      return post(API.orderHistory, body).then(res => {
        return res;
      });
    },
  },
};
